var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{staticClass:"no-print",attrs:{"id":"nav"}},[_c('v-toolbar',{attrs:{"color":"blue darken-2"}},[_c('v-toolbar-title',{staticClass:"dddd",attrs:{"color":"#fff"}},[_vm._v("আমার Manager")])],1)],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }